// ButtonReusable.js
import React from "react";
import { Button as MuiButton } from "@material-ui/core";

const ButtonReusable = ({ children, onClick,disabled }) => {
  return (
    <MuiButton
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundColor: disabled ? undefined : "#90C54B",
        color: "white",             // white text
        marginBottom: "12px",       // margin bottom
        borderRadius: "6px",
        fontWeight: "bold",
        textTransform: "none",      // keep text as-is
      }}
    >
      {children}
    </MuiButton>
  );
};

export default ButtonReusable;
